import { render, staticRenderFns } from "./SingleStockCounts.vue?vue&type=template&id=70555064&scoped=true"
import script from "./SingleStockCounts.vue?vue&type=script&lang=js"
export * from "./SingleStockCounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70555064",
  null
  
)

export default component.exports